import React from 'react';

import { DNABox, DNAButton, DNAModal, DNAText } from '@alucio/lux-ui';
import { DNAModalVariant } from '../DNAConnectedModal';
interface CloseConfirmationProps {
  onClose: () => void
}

const CloseConfirmation:DNAModalVariant<CloseConfirmationProps> = (props) => {
  const { toggleModal, onClose } = props

  const handleContinueEditing = () => {
    toggleModal()
  }

  const handleCloseWithoutSaving = () => {
    toggleModal()
    onClose()
  }

  return (
    <DNAModal>
      <DNAModal.Header>
        <DNAText h5>Unsaved changes</DNAText>
      </DNAModal.Header>
      <DNAModal.Body>
        <DNABox style={{ padding: 8 }}>
          <DNAText status="tertiary">
            All changes will be lost.
          </DNAText>
        </DNABox>
      </DNAModal.Body>
      <DNAModal.Confirmation>
        <DNAButton status="tertiary" onPress={handleContinueEditing}>
          Continue editing
        </DNAButton>
        <DNAButton onPress={handleCloseWithoutSaving}>
          Close without saving
        </DNAButton>
      </DNAModal.Confirmation>
    </DNAModal>
  )
};

export default CloseConfirmation;
